<template>
  <v-container
    id="wizard"
    tag="section"
  >
    <base-material-wizard-unit
      v-model="tab"
      :available-steps="availableSteps"
      :items="tabs"
      class="mx-auto"
      @click:next="next"
      @click:prev="tab--"
    >
      <v-tab-item class="pb-12">
        <form
          action=""
          data-vv-scope="original"
        >
          <div class="text-center display-1 font-weight-dark mb-6">
            Original Device Name
          </div>

          <v-row
            class="mx-auto"
            justify="space-around"
            style="max-width: 700px;"
          >
            <v-col
              cols="auto"
              class="text-center"
            >
              <v-card
                :class="originaldevice ? 'success--text' : 'grey--text'"
                class="mx-auto mt-0 d-inline-flex v-card--account"
                outlined
                height="106"
                width="106"
              >
                <v-icon
                  class="mx-auto"
                  size="96"
                >
                  mdi-memory
                </v-icon>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                name="Current Device Crpyto ID*"
                :rules="{
                  required: true,
                }"
              >
                <v-text-field
                  v-model="originaldevice"
                  :error-messages="errors"
                  color="secondary"
                  label="Current Device Crpyto ID*"
                  prepend-icon="mdi-border-left"
                  validate-on-blur
                />
              </validation-provider>
            </v-col>
          </v-row>
        </form>
      </v-tab-item>

      <v-tab-item class="pb-12">
        <v-form
          ref="form1"
        >
          <div class="text-center display-1 font-weight-dark mb-6">
            New Device Name. Must NOT be an existing device name.
          </div>

          <v-row
            class="mx-auto"
            justify="space-around"
            style="max-width: 700px;"
          >
            <v-col
              cols="auto"
              class="text-center"
            >
              <v-card
                :class="newdevice ? 'success--text' : 'grey--text'"
                class="mx-auto mt-0 d-inline-flex v-card--account"
                outlined
                height="106"
                width="106"
              >
                <v-icon
                  class="mx-auto"
                  size="96"
                >
                  mdi-memory
                </v-icon>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="newdevice"
                :rules="rules"
                color="secondary"
                label="New Device Crpyto ID*"
                prepend-icon="mdi-border-right"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-tab-item>
      <v-tab-item class="pb-12">
        <div class="text-center display-2 black--text font-weight-dark mb-6">
          Safe unit settings.
        </div>

        <form
          action=""
          data-vv-scope="settings"
        >
          <v-row
            class="mx-auto"
            justify="space-around"
            style="max-width: 700px;"
          >
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-menu
                ref="menu"
                v-model="menueodtime"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="onboardEodTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="onboardEodTime"
                    label="EOD Time"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-if="menueodtime"
                  v-model="onboardEodTime"
                  header-color="blue"
                  format="24hr"
                  full-width
                  @click:minute="$refs.menu.save(onboardEodTime)"
                />
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-select
                v-model="printCopies"
                color="primary"
                :items="numcopies"
                outlined
                label="Number of Copies"
              />
              <v-row>
                <v-col class="xs">
                  <v-switch
                    v-model="disabledevice"
                    label="Disable Device"
                    color="primary"
                  />
                </v-col>
                <v-col class="xs">
                  <v-switch
                    v-model="printEod"
                    label="Autoprint EOD"
                    color="primary"
                  />
                </v-col>
              </v-row>
              <v-slider
                v-model="depositTimeout"
                label="Deposit Timeout (S)"
                color="primary"
                step="5"
                min="10"
                max="30"
                thumb-label="always"
              />
            </v-col>
          </v-row>
        </form>
      </v-tab-item>
      <v-tab-item class="pb-12">
        <div class="text-center display-2 black--text font-weight-dark mb-6">
          Please review the summary. This action can not be reversed.
        </div>

        <form
          action=""
          data-vv-scope="summary"
        >
          <v-row
            class="mx-auto"
            justify="space-around"
            style="max-width: 700px;"
          >
            <v-col
              cols="4"
            >
              <div class="display-1 black--text font-weight-dark">
                Original Device: {{ originaldevice }}
              </div>
            </v-col>
            <v-col
              cols="4"
              class="text-center"
            >
              <v-card
                :class="newdevice ? 'success--text' : 'grey--text'"
                class="mx-auto mt-0 d-inline-flex v-card--account"
                outlined
                height="106"
                width="106"
              >
                <v-icon
                  class="mx-auto"
                  size="96"
                >
                  mdi-chevron-triple-right
                </v-icon>
              </v-card>
            </v-col>
            <v-col
              cols="4"
            >
              <div class="display-1 black--text font-weight-dark mb-2">
                New Device:{{ newdevice }}
              </div>
              <div class="display-1 black--text font-weight-dark">
                EOD Time: {{ onboardEodTime }} <br>
                Timezone: {{ timezone }} <br>
                AutoPrint EOD: {{ printEod }} <br>
                Num Copies: {{ printCopies }} <br>
                Deposit Timeout: {{ depositTimeout }} <br>
              </div>
            </v-col>
          </v-row>
        </form>
      </v-tab-item>
    </base-material-wizard-unit>
  </v-container>
</template>

<script>
  export default {
    name: 'DashboardFormsWizard',

    data: () => ({
      newdevice: '',
      unique: true,
      originaldevice: '',
      printEod: true,
      // eodTime: this.eodTime, // hh:mm
      onboardEodTime: '',
      menueodtime: false,
      eodTime: 0,
      printCopies: 1,
      numcopies: [1, 2, 3, 4],
      timezone: 'EST',
      depositTimeout: 20,
      disabledevice: false,
      disabled: false,
      onlyspace: false,
      mustdash: true,
      filterchars: true,
      existingunits: [],
      tab: 0,
      tabs: ['Original', 'New', 'Settings', 'Summary']
    }),
    computed: {
      rules () {
        const rules = []
        let existingunits = this.$store.getters.ssunits.map(unit => unit.crypto_idnum)
        if (this.unique) {
          const rule =
            v => (!existingunits.includes(v)) || 'Unit ID must be unique and not be an existing unit name'

          rules.push(rule)
        }
        if (!this.onlyspace) {
          const rule =
            v => v.trim().length || 'Can not be only whitespace characters'

          rules.push(rule)
        }
        if (this.max) {
          const rule =
            v => (v || '').length <= this.max ||
              `A maximum of ${this.max} characters is allowed in a site name`

          rules.push(rule)
        }
        if (this.mustdash) {
          const rule =
            v => (v || '').indexOf('-') > 0 ||
              'Device Name must include a dash'

          rules.push(rule)
        }
        if (!this.allowSpaces) {
          const rule =
            v => (v || '').indexOf(' ') < 0 ||
              'No spaces are allowed'

          rules.push(rule)
        }
        if (this.filterchars) {
          const rule =
            v => !v.match(/\\t|[#\$\.]/gi) || ' $ # [ ] tabs are not allowed in a site name'
          rules.push(rule)
        }
        return rules
      },
      scope () {
        if (this.tab === 0) return 'original'
        else if (this.tab === 2) return 'settings'
        else if (this.tab === 3) return 'summary'
        return 'new'
      },
      availableSteps () {
        const steps = [0]

        if (
          this.originaldevice
        ) steps.push(1)

        if (this.newdevice && steps.includes(1)) steps.push(2)
        if (this.printEod && this.onboardEodTime && steps.includes(2)) steps.push(3)
        if (
          this.originaldevice &&
          this.newdevice &&
          steps.includes(3)
        ) steps.push(4)

        return steps
      }
    },
    watch: {
      newdevice: 'validateField',
      max: 'validateField',
    },
    created () {
      this.loading = true
      this.$store.dispatch('loadSiteConfigs')
      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
    },

    methods: {
      next () {
        this.validateForm(this.scope).then(item => {
          if (!item) return

          if (this.tab === this.tabs.length - 1) { // this is the end...
            this.validateForm.originaldevice = ''
            this.validateForm.new = ''
            this.$validator.fields.items.forEach(f => {
              f.reset()
              f.name = ''
            })
            let devrec = this.newdevice.split('-')
            let CUSTOMER_POS = 0
            let UNIT_POS = 1
            let customerid = devrec[CUSTOMER_POS]
            let unitid = devrec[UNIT_POS]
            let rec = {
              safeid: this.originaldevice,
              customerId: customerid.trim(),
              unitId: unitid.trim(),
              printEod: this.printEod,
              eodTime: this.onboardEodTime,
              printCopies: this.printCopies,
              timezone: this.timezone,
              depositTimeout: this.depositTimeout,
              disabled: this.disabledevice
            }
            this.$store.dispatch('sendonboardcmd', rec)
            let newunitidrec = { crypto_idnum: customerid.trim() + '-' + unitid.trim() }
            this.$store.dispatch('createsmartsafeunit', newunitidrec)
            this.$store.dispatch('loadunits')
            this.originaldevice = null
            this.newdevice = null
            this.tab = 0
            this.printEod = true
            this.onboardEodTime = ''
            this.eodTime = 0
            this.printCopies = 1
            this.timezone = 'EST'
            this.depositTimeout = 20
            alert('The command has been issued to the device')
          } else {
            this.tab++
          }
        })
      },
      validateField () {
        this.$refs.form1.validate()
      },
      validateForm (scope) {
        return this.$validator.validateAll(scope)
      }
    }
  }
</script>

<style lang="sass">
  .v-card.v-card.v-card--account
    border-color: currentColor
    border-width: 4px

    .v-icon
      color: inherit

  .v-card--account,
  .v-card--account:before
    border-radius: 50%

</style>
